export const ORGANIZATION_REQUESTED = 'ORGANIZATION_REQUESTED';
export const ORGANIZATION_SUCCESS = 'ORGANIZATION_SUCCESS';
export const ORGANIZATION_FAILED = 'ORGANIZATION_FAILED';

export const ORGANIZATION_LIST_REQUESTED = 'ORGANIZATION_LIST_REQUESTED';
export const ORGANIZATION_LIST_SUCCESS = 'ORGANIZATION_LIST_SUCCESS';
export const ORGANIZATION_LIST_FAILED = 'ORGANIZATION_LIST_FAILED';

export const ORGANIZATION_SPOTS_REQUESTED = 'ORGANIZATION_SPOTS_REQUESTED';
export const ORGANIZATION_SPOTS_FETCH_STARTED = 'ORGANIZATION_SPOTS_FETCH_STARTED';
export const ORGANIZATION_SPOTS_SUCCESS = 'ORGANIZATION_SPOTS_SUCCESS';
export const ORGANIZATION_SPOTS_FAILED = 'ORGANIZATION_SPOTS_FAILED';
